import { Wizard } from '@src/features/ActionPaths/Wizard';
import { ContextProvider as WizardProvider } from '@src/features/ActionPaths/Wizard/context';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import React from 'react';

/**
 * Page: Manage
 *
 * Provides a step-by-step wizard interface for composing an action path.
 *
 * @returns {Element}
 * @constructor
 */
export function Manage() {
  return (
    <ErrorHandler location="src/pages/private/ActionPaths/Manage/Manage.jsx">
      <WizardProvider>
        <Wizard />
      </WizardProvider>
    </ErrorHandler>
  );
}
